import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { EmptyState, PageHeader } from "@/components/shared/Common";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function Notifications() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const base = useLocation().pathname.startsWith("/terreno") ? "/terreno" : "";
  const load = () => api.get("/notifications", { params: { limit: 100 } }).then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  const read = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div data-testid="notifications-page">
      <PageHeader eyebrow="Centro de notificaciones" title="Notificaciones" subtitle={`${data.unread} sin leer`}
        actions={data.unread > 0 && <Button data-testid="notifications-read-all-btn" variant="outline" className="rounded-full" onClick={readAll}>Marcar todas como leídas</Button>} />
      <div className="syc-card overflow-hidden">
        {data.items.length === 0 && <EmptyState title="Sin notificaciones" />}
        {data.items.map((n) => (
          <div key={n.id} data-testid={`notification-item-${n.id}`} className={`flex items-start gap-4 px-6 py-4 border-b border-[#f0f2ee] last:border-0 ${n.read_at ? "" : "bg-[#f6fbf2]"}`}>
            <span className={`mt-1.5 h-2 w-2 rounded-full shrink-0 ${n.read_at ? "bg-[#d4d9d0]" : "bg-[#5CD500]"}`} />
            <div className="flex-1 min-w-0">
              <div className="text-sm">{n.message}</div>
              <div className="text-xs text-[#8a9584] mt-1">{fmtDateTime(n.created_at)} · {n.module}</div>
              {n.resource_type === "ot_day" && <Link data-testid={`notification-link-${n.id}`} to={`/rrhh/asistencia-dia?ot=${n.resource_id}`} className="text-xs font-semibold text-[#258F00]">Ver asistencia del día →</Link>}
              {n.resource_type === "chat_thread" && <Link data-testid={`notification-link-${n.id}`} to={`${base}/mensajes?t=${n.resource_id}`} className="text-xs font-semibold text-[#258F00]">Abrir conversación →</Link>}
              {n.resource_type === "ticket" && <Link data-testid={`notification-link-${n.id}`} to={`/soporte/${n.resource_id}`} className="text-xs font-semibold text-[#258F00]">Ver ticket →</Link>}
            </div>
            {!n.read_at && <Button data-testid={`notification-read-btn-${n.id}`} size="sm" variant="ghost" onClick={() => read(n.id)}>Marcar leída</Button>}
          </div>
        ))}
      </div>
    </div>
  );
}
